module.exports = __webpack_public_path__ + "img/appointments.1960cd0c.svg";